import { render, staticRenderFns } from "./VehicleResultCard.vue?vue&type=template&id=cb107f8e&scoped=true&"
import script from "./VehicleResultCard.vue?vue&type=script&lang=js&"
export * from "./VehicleResultCard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleResultCard.vue?vue&type=style&index=0&id=cb107f8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb107f8e",
  null
  
)

export default component.exports